import React from 'react'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px auto 30px auto;
  width: 100%;
`

const StyledTypeButton = styled.button`
  color: ${ ({ theme, active }) => active ? theme.colors.black : theme.colors.grey };
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Bold };
  line-height: 1.22;
  padding: 10px;
  transition: .3s;
  ${ media.tablet`
    font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
    font-size: 2.8rem;
    line-height: 1.6;
  ` }
`

class ArBlogItemsTypeSelector extends React.Component {
  render () {
    return (
      <StyledContainer>
        <StyledTypeButton
          active={this.props.activeType === 'article'}
          onClick={() => this.props.onTypeSelect('article')}>
            Articles
        </StyledTypeButton>
        <StyledTypeButton
          active={this.props.activeType === 'press_releases'}
          onClick={() => this.props.onTypeSelect('press_releases')}>
            Press Releases
        </StyledTypeButton>
      </StyledContainer>
    )
  }
}

export default ArBlogItemsTypeSelector
